import { Injectable } from '@angular/core';

interface CsvData {
  headers: string[];
  rows: (string[] | object)[];
}

@Injectable({ providedIn: 'root' })
export class Exporter {
  asFormat(content: string, name: string, mimetype: string, extension?: string) {
    const file = new Blob([content], { type: mimetype });
    const ext = extension || mimetype.split('/')[1];
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file);
    link.download = `${name}.${ext}`;
    link.click();
  }

  asCsv(data: CsvData, name: string) {
    let content = data.headers.join(',') + '\n';
    for (const row of data.rows) {
      let values: string[];
      if (!Array.isArray(row)) {
        values = data.headers.map((col) => row[col] || '');
      } else {
        values = row;
      }
      content += values.map((v) => '"' + String(v).replace(/"/g, '""') + '"').join(',') + '\n';
    }
    this.asFormat(content, name, 'text/csv');
  }
}
